export default __webpack_public_path__ + "static/media/world_wide_web.6fb46c67.svg";